import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { DigitOnlyModule } from '@uiowa/digit-only';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { CrmModelDrivenFormErrorComponent } from '../model-driven-form-error/model-driven-form-error.component';
import { FieldWarningService } from '../model-driven-form-error/field-warning.service';
import { ScoreService } from '../../../../shared-services';

@Component({
  templateUrl: './score.html',
  imports: [
    CommonModule,
    MatInputModule,
    ReactiveFormsModule,
    DigitOnlyModule,
    TranslateModule,
    GalaxyFormFieldModule,
    CrmModelDrivenFormErrorComponent,
  ],
  providers: [FieldWarningService],
  styleUrls: ['../renderers.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
})
export class ScoreRendererComponent implements OnInit {
  fieldId!: string;
  control!: FormControl<number>;
  label!: string;
  readOnly!: boolean;

  constructor(private readonly scoreService: ScoreService) {}

  ngOnInit(): void {
    this.scoreService.getScoreForProfile$(this.fieldId).subscribe((score) => {
      if (score !== null) {
        this.control.setValue(score);
      }
    });
  }
}
